import classNames from "classnames";
import * as React from "react";
import { HierarchyEntity } from "~/EasyProjectsCommon/TaskHierarchyNameHelper";
import { Chips } from "~/sharedComponents/chips/Chips";
import { Highlighter } from "~/sharedComponents/highlighter";
import { Box, Flex, Text } from "~/sharedComponents/layout";
import { ListItem } from "~/sharedComponents/list";
import { RowCheckMark } from "~/sharedComponents/list/ListRowDefault";
import { EntityThumbnail } from "~/sharedComponents/thumbnails/EntityThumbnail";
import { getThumbnailDataByType } from "~/sharedComponents/thumbnails/helpers";
import { ThumbnailDataItem } from "~/sharedComponents/thumbnails/types";
import * as styles from "../../sharedComponents/list/VirtList.less";
import { VirtListRowProps } from "../list/BaseList";
import { Qtip } from "../tooltip";
import { getRowStyle } from "./listRowHelpers";

export type EntityPathItem = HierarchyEntity<ListItem & ThumbnailDataItem>;

type PathRowProps = VirtListRowProps<EntityPathItem> & { isBold?: boolean; chipName?: string };

export const EntityPathRow: React.FC<PathRowProps> = props => {
    const { item, textForHighlight, children, isBold, selected, chipName, isMarkedList } = props;
    const hierarchyPart = !textForHighlight ? item.hierarchyPart : undefined;
    const thumbnailItem = getThumbnailDataByType(item);
    const isShowRightPart = isMarkedList || chipName;
    const showTooltip = !!(props.isItemDisabled?.(item) && props.disabledItemTooltip);

    return (
        <Qtip isVisible={showTooltip}>
            <Flex
                gap={8}
                flexWrap="nowrap"
                title={item.label}
                className={classNames(getRowStyle(props), isBold && styles.bold)}
            >
                <Flex flex="1 1" overflow="hidden" alignItems="center">
                    <div className={styles.hierarchy} dangerouslySetInnerHTML={{ __html: hierarchyPart }} />
                    {thumbnailItem && (
                        <Box marginRight={8}>
                            <EntityThumbnail item={thumbnailItem} />
                        </Box>
                    )}
                    <Highlighter className={styles.label} text={item.label} textForHighlight={textForHighlight} />
                    {children}
                </Flex>
                {isShowRightPart && (
                    <Flex flex="0 0" alignItems="center" marginLeft="auto" maxWidth="30%">
                        {chipName && (
                            <Flex flex="0 0" maxWidth="100%" className={classNames(isMarkedList && styles.is_marked)}>
                                <Chips shrinkable={true}>
                                    <Text title={chipName} truncate={true}>
                                        {chipName}
                                    </Text>
                                </Chips>
                            </Flex>
                        )}
                        {isMarkedList && (
                            <Flex flex="1 0" width={16} minWidth={16}>
                                <RowCheckMark selected={selected} />
                            </Flex>
                        )}
                    </Flex>
                )}
            </Flex>
            <Box>{props.disabledItemTooltip}</Box>
        </Qtip>
    );
};
